var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHome2Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1739H12.0075",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 9.09061V13.2573C18.6668 16.3999 18.6668 17.9714 17.6905 18.9476C16.7142 19.9239 15.1428 19.9239 12.0002 19.9239C8.85746 19.9239 7.28612 19.9239 6.3098 18.9476C5.3335 17.9714 5.3335 16.3999 5.3335 13.2573V9.09061",
    fill: "#A4C7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 9.09061V13.2573C18.6668 16.3999 18.6668 17.9714 17.6905 18.9476C16.7142 19.9239 15.1428 19.9239 12.0002 19.9239C8.85746 19.9239 7.28612 19.9239 6.3098 18.9476C5.3335 17.9714 5.3335 16.3999 5.3335 13.2573V9.09061",
    stroke: "#065EEA",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7502 4.50727L5.3335 9.09061C6.72238 9.64616 9.5835 10.7573 9.91683 10.7573C10.2502 10.7573 14.7779 10.2017 17.0002 9.92394L18.6668 9.09061L13.6668 4.92394L12.4168 4.09061L10.7502 4.50727Z",
    fill: "#A4C7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1739H12.0075",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3332 10.7573L16.7139 7.28684C14.4917 5.15602 13.3806 4.09061 11.9998 4.09061C10.6191 4.09061 9.50801 5.15602 7.2858 7.28684L3.6665 10.7573",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome2Active);
export default __webpack_public_path__ + "static/media/ic-Home2-active.06d42bf7ecd33e4092cf7ded88591248.svg";
export { ForwardRef as ReactComponent };